export default {
  eyebrow: 'Portal de socios',
  title: 'Calculadora de tarifa de servicio',
  description: 'Estima los ingresos por tarifa de servicio generados en los restaurantes de tu cuenta de socio.',
  toasts: {
    load_error: 'No se pudo cargar la configuración de tu tarifa de servicio.',
  },
};
